import React from "react";
import { Check } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useReveal } from "../hooks/useReveal";
import { heroImages } from "../mock";

const About = () => {
  const { t, lang } = useLang();
  const [imgRef, imgVisible] = useReveal();
  const [txtRef, txtVisible] = useReveal();

  return (
    <section id="nosotros" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div ref={imgRef} className={`reveal-left ${imgVisible ? "is-visible" : ""} relative`}>
          <div className="rounded-[26px] overflow-hidden shadow-xl">
            <img src={heroImages.about} alt="About ZD" className="w-full h-[420px] object-cover" />
          </div>
          <div className="absolute -bottom-6 right-6 bg-white rounded-2xl shadow-xl p-5 max-w-[220px] border border-zinc-50">
            <div className="font-zh font-black text-xl" style={{ color: "var(--zd-red)" }}>正大律师事务所</div>
            <div className="text-xs mt-1" style={{ color: "var(--zd-slate)" }}>ZD Consulting México</div>
          </div>
        </div>

        <div ref={txtRef} className={`reveal-right ${txtVisible ? "is-visible" : ""}`}>
          <span className={`text-sm font-bold uppercase tracking-wider ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-red)" }}>{t.about.tag}</span>
          <h2 className={`font-display font-bold text-3xl md:text-4xl mt-3 leading-tight ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-ink)" }}>
            {t.about.title}
          </h2>
          <div className="h-1 w-16 mt-4 rounded-full" style={{ background: "var(--zd-gold)" }} />

          <p className={`mt-6 leading-relaxed ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-slate)" }}>{t.about.p1}</p>
          <p className={`mt-4 leading-relaxed ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-slate)" }}>{t.about.p2}</p>
          <p className={`mt-4 leading-relaxed ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-slate)" }}>{t.about.p3}</p>

          <ul className="mt-8 space-y-3">
            {t.about.points.map((p, i) => (
              <li key={i} className="flex items-center gap-3">
                <span className="h-6 w-6 rounded-full grid place-items-center flex-shrink-0" style={{ background: "rgba(110,42,58,.1)" }}>
                  <Check className="h-4 w-4" style={{ color: "var(--zd-red)" }} />
                </span>
                <span className={`font-medium ${lang === "zh" ? "font-zh" : ""}`} style={{ color: "var(--zd-ink)" }}>{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
